"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var zindex = function (key) {
    return function (props) {
        var zindexes = props.theme.zindexes;
        if (!zindexes) {
            throw new Error("theme.zindexes does not seems to be defined");
        }
        var value = zindexes.indexOf(key);
        if (value < 0) {
            throw new Error("zindexes.".concat(key, " seems not to be defined in your theme object"));
        }
        return value;
    };
};
exports.default = zindex;
//# sourceMappingURL=zindex.js.map